(function () {
  function initTabbingSection(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.custom-tabbing__tab'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.custom-tabbing__panel'));

    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index);
      });

      tab.addEventListener('keydown', function (event) {
        var newIndex = null;

        if (event.key === 'ArrowRight') {
          newIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          newIndex = (index - 1 + tabs.length) % tabs.length;
        }

        if (newIndex !== null) {
          event.preventDefault();
          tabs[newIndex].focus();
          activate(newIndex);
        }
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.custom-tabbing');
    sections.forEach(initTabbingSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added or re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.custom-tabbing');
    if (section) initTabbingSection(section);
  });
})();
